export const numericInputRegExp = /^0+0|^0+\d/g;

export const extractDocumentFormat = /\w+$/gm;
